export function historySlider() {
    const sliderWrap = $(".history-slider");
    const slider = sliderWrap.find(".slider");
    const arrowBtn = '<button class="slick-arrow clone"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.73 7.78">\n' +
        '    <path d="M11.31,0,6.36,5,1.41,0,0,1.41l5,5H5L6.36,7.78l6.37-6.37Z"/>\n' +
        '</svg></button>';

    slider.slick({
        infinite: true,
        speed: 300,
        useCSS: false,
        useTransform: false,
        slidesToShow: 1,
        adaptiveHeight: true,
        mobileFirst: true,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    infinite: false,
                    vertical: true,
                    verticalSwiping: true,
                    adaptiveHeight: false
                }
            }
        ]
    });
    let maxHeight = -1;
    $('.slick-slide').each(function () {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        } else {
            $(this).css('padding', Math.ceil((maxHeight - $(this).height()) / 2) + 'px 0');
        }
    });

    sliderWrap.append(arrowBtn);

    $('.slick-arrow.clone').on('click', function () {
        slider.slick('slickGoTo', 0);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/historySlider.js